//const PROMOCION_API_URL = "http://localhost:8082";
//const PROMOCION_API_URL = 'http://192.168.236.242:8083'
import axios from "axios";
import IPServie from "../service/ConectionDataService";
class RolesUser {
  async getRole(userLogin) {
    let http_ = IPServie.getURL();
    let arrayModulos=[];
    
    var url = http_ +"/acumulacion/mf/autentication/getatribuciones/"+userLogin;
    await axios
        .get(url)
        .then(function (response) {
            arrayModulos = response.data;
            console.log(arrayModulos.aplicacion.modulo);
            var r1 = new RolesUser();
            r1.getTransaccion(arrayModulos.aplicacion.modulo);
        })
        .catch(function (error) {
          console.log(error);
        });
        
    return arrayModulos.aplicacion.modulo;
  }
  getPermiso(modulos,modulo) {
      //RolesUser.getTransaccion(modulos);
      let tam = modulos.length;
      for(let i = 0; i < tam; i++){
          //console.log(modulos[i].idmodulo[0]);
          if(modulos[i].idmodulo[0] ==  modulo){
              return 1;
          }
      }
      return 0;
  }
  getTransaccion(modulos){
    let transacciones=[];
    for(let i = 0; i < modulos.length; i++){
        transacciones.push(modulos[i].transaccion);
    }
    //console.log(transacciones);
    return 1;
  }
  getPermisoPagina(modulos,modulo,pagina) {
    //RolesUser.getTransaccion(modulos);
    let tam = modulos.length;
    let trasac =[];
    for(let i = 0; i < tam; i++){
        console.log(modulos[i].idmodulo[0]);
        if(modulos[i].idmodulo[0] ==  modulo){
          //console.log(modulos[i].idmodulo[0]);
          trasac=modulos[i].transaccion;
          console.log(trasac);
          for(var j=0; j<trasac.length ; j++){
            if(trasac[j].idtransaccion[0] == pagina){
              return 1;
            }

          }
          
            
        }
    }
    return 0;
}
}
export default new RolesUser();
